import { dqgj } from '@/axios'
import  feedBack  from '../components/feedback.vue'
let that;
export default{
	data(){
		return{
			time:"",
			title:"",
			content:"",
			url:"",
			img:"",
			class_id:"",
			u_name:"",
			feedback:"",
			feedWin:false
		}
	},
	components:{feedBack},
	methods:{
		// 获取数据
		getdata(){
			dqgj.dqgjUpdateGet({id:that.$route.query.id}).then(res => {
				that.title = res.data.title!=""?res.data.title:'暂无标题'
				that.content = res.data.content!=""?res.data.content:'暂无数据'
				that.url = res.data.url!=""?res.data.url:'暂无数据';
				that.feedback = res.data.feedback!=""?res.data.feedback:'暂无数据';
				that.class_id = res.data.class_id==1?'建言献策':'匿名投诉';
				that.time = that.$changeTime(res.data.addtime);
				that.img = res.data.sz_img!=""?res.data.sz_img.search("http")!=-1?res.data.sz_img:'http://'+res.data.ym+'/'+res.data.sz_img:'暂无数据'
			})
		},
		// 接受返回数据
		getFeed(data){
			that.feedback = data;
		},
		//关闭反馈弹窗
		closeFeed(){
			that.feedWin = false;
			that.getdata();
		}
	},
	mounted() {
		that.getdata();
	},
	created() {
		that = this;
		that.$emit('selectTop',2)
	}
}